/*
 * @Description: 
 * @Author: xiong.zhou@dmall.com
 * @Date: 2022-03-18 10:29:17
 * @LastEditors: xiong.zhou@dmall.com
 * @LastEditTime: 2025-04-23 22:43:25
 */
import request from '../request';

// 获取作品搜索列表
export function getWorkSearchList(params) {
    return request('/zuoPin/getZuoPinList', {
        method: 'GET',
        params
    });
}

// 获取文章搜索列表
export function getArticleSearchList(params) {
    return request('/article/getArticleList', {
        method: 'GET',
        params
    });
}

// 获取工具搜索列表
export function getToolSearchList(params) {
    return request('/tool/toolList', {
        method: 'GET',
        params
    });
}


// 获取设计师搜索列表
export function getUserSearchList(params) {
    return request('/user/getUserAttentionByUserInfo', {
        method: 'GET',
        params
    });
}

// 获取素材搜索列表
export function getMaterialSearchList(params) {
    return request('/material/getMaterialList', {
        method: 'GET',
        params
    });
}

// 获取图片搜索列表
export function getImageSearchList(params) {
    return request('/image/list', {
        method: 'GET',
        params
    });
}

// 获取项目案例搜索列表
export function getProjectCaseList(params) {
    return request('/project', {
        method: 'GET',
        params
    });
}

// 获取搜索数量
export function getSearchCount(params) {
    return request('/zuoPin/search/count', {
        method: 'GET',
        params
    });
}

// 获取课程搜索列表
export function getCourseList(params) {
    return request('/lesson/list', {
        method: 'GET',
        params
    });
}

// 获取搜索推荐词
export function getSearchRecommend(params) {
    return request('/home/page/search/recommend', {
        method: 'GET',
        params
    });
}

